import React from 'react';
import './style/normal.css';

const Normal = ({removeMessage, message}) =>
    (
    <div className="fieldWrapper messageBlock">
        <div className="normalContent">{message} <span className="messageClose icon" onClick={removeMessage}> </span></div>
    </div>
);

export default Normal;
